import {GetterTree, MutationTree, Module, ActionTree} from 'vuex'
import {RootState, RefState} from '../types'
import axios from 'axios'
import {apiUrl, externalApiUrl, externalApiKey} from '@/config/service'

type RefGetter = GetterTree<RefState, RootState>

const state: RefState = {
  departement: null,
  civilite: null,
  origine: null,
  pays: null,
  proportionBailleurs: null,
  role: null,
  situation: null,
  taille: null,
  typeDemande: null,
  typeEchange: null,
  urgenceDemande: null,
  typeEntite: null,
  statutEssai: null,
  modelesEssai: null,
  statut: null,
  offre: null,
  typeRemise: null,
  coach: null,
  typeOption: null
}

export const getters: RefGetter = {
  refGetter: (state) => state
}

export const actions: ActionTree<RefState, RootState> = {
  async getRefAction({commit}, name) {
    const {data} = await axios.get(`${apiUrl}/ref/${name}`, {params: {sortBy: 'RANG', orderBy: 'asc'}})
    commit('getRefMutation', {name, data})
    return data
  }
}

const mutations: MutationTree<RefState> = {
  getRefMutation(state: any, {name, data}) {
    state[name] = data
  }
}

export const ref: Module<RefState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
